<div class="container">
  <div
    class="left"
    [class.mobile]="isHeaderMobile"
  >
    <ng-container *ngIf="!guestMode">
      <a
        class="display-name"
        [routerLink]="user.portalLink"
        merriNoFocusLink
        *ngIf="!showEventSelector"
        [class.always-show]="showDisplayName()"
        (click)="onPortalLinkClick()"
      >
        <ng-container *ngIf="!isHeaderMobile">
          {{ getDisplayName() }}
        </ng-container>
        <ng-container *ngIf="isHeaderMobile">
          <mat-icon
            svgIcon="home_outline"
            class="mobile-header"
          ></mat-icon>
        </ng-container>
      </a>

      <!-- Event Selector for Client Users with multiple events (replaces dashboard link) -->
      <div
        class="event-selector-container"
        *ngIf="showEventSelector"
      >
        <a
          [routerLink]="user.portalLink"
          merriNoFocusLink
          (click)="onPortalLinkClick()"
        >
          <mat-icon
            svgIcon="home_outline"
            class="mobile-header"
          ></mat-icon>
        </a>
        <app-user-event-selector></app-user-event-selector>
      </div>
    </ng-container>

    <!-- Guest Mode Display -->
    <span
      class="display-name guest"
      *ngIf="guestMode"
    >
      <ng-container *ngIf="!isHeaderMobile">
        {{ getDisplayName() }}
      </ng-container>
      <ng-container *ngIf="isHeaderMobile">
        <mat-icon
          svgIcon="home_outline"
          class="mobile-header"
        ></mat-icon>
      </ng-container>
    </span>
  </div>
  <div class="right">
    <app-referral-rewards-feature-button
      source="ProtectedHeader"
      *ngIf="showReferralBtn"
    ></app-referral-rewards-feature-button>
    <app-learn-more-menu-button *ngIf="guestMode"></app-learn-more-menu-button>
    <app-new-feature-carousel-trigger
      *ngIf="!guestMode"
      [isMobile]="mobileView"
    ></app-new-feature-carousel-trigger>
    <button
      *ngIf="!mobileView && !guestMode"
      class="ts-button base text disable-focus"
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="menu"
    >
      Need Help?
    </button>
    <app-account-upgrade-button
      class="account-upgrade-button-protected-header"
      source="Upgrade Button - Website Header (protected)"
    ></app-account-upgrade-button>

    <mat-menu
      #menu="matMenu"
      class="protected-header-help-menu"
    >
      <a
        mat-menu-item
        class="menu-item"
        (click)="onTutorialsClick()"
      >
        Help Center
      </a>
      <a
        mat-menu-item
        class="email-us menu-item"
        href="mailto:{{ HELP_EMAIL }}"
        rel="noopener nofollow noreferrer"
      >
        {{ HELP_EMAIL }}
      </a>
    </mat-menu>
    <app-user-icon-menu
      class="user-icon"
      *ngIf="!guestMode"
      [user]="user"
      [includeExtras]="mobileView"
    ></app-user-icon-menu>
  </div>
</div>
<!-- 
This button below is to alleviate an issue where, when not having the mat-flat-button, 
the styles of other buttons were being affected. It is not visible and is only used to apply 
the styles of the mat-flat-button to the other buttons.
-->
<button
  mat-flat-button
  style="display: none"
></button>
